



























import { AuthStoreHelper, RootStoreHelper } from '../../core/mixins';
import ModalCheckboxList from '../../core/components/ModalCheckboxList.vue';
import { Component, Emit, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import {
    PlayBackInfo,
    PlaybackState,
    mapFromRangeToRange,
    getDateFromDateFormatApi,
    getStringTimeFromDate,
    sortObjectByPropertyName
} from '../../core/utils';
import CardPlayBackInfo from './CardPlayBackInfo.vue';
import { UserCustomization } from '../../core/models';
import { UserService } from '../../core/api';
import { Destroyed } from '../../core/decorators';

@Component({
    components: {
        ModalCheckboxList
    }
})
export default class AnalyticHarvestColumns extends Mixins(RootStoreHelper) {
    visibleModal: boolean = false;
    modalTitle: string = 'Columnas visibles';
    defaultChecked: boolean = true;
    defaultSettings: object = {
        checked: this.defaultChecked
        // disabled: false,
        // loading: false,
        // disabledTooltip: '',
        // icon: null
    };
    optionalOptions: object = {
        // variable_report_performance: {
        //     title: 'Rendimiento',
        //     key: VariablesTypes.PERFORMANCE,
        //     checked: false
        // },
        // variable_report_humidity: {
        //     title: 'Humedad',
        //     key: VariablesTypes.HUMIDITY,
        //     checked: false
        // },
        // variable_report_total_distance: {
        //     title: 'Distancia total recorrida',
        //     key: VariablesTypes.TOTAL_DISTANCE,
        //     checked: false
        // },
        // variable_report_total_hours_operational: {
        //     title: 'Horas totales de operación del motor',
        //     key: VariablesTypes.TOTAL_HOURS_OPERATIONAL,
        //     checked: false
        // }
    };
    defaultOptions: object = {
        "policy__number": {
            title: 'Poliza',
            key: 'policy__number',
            ...this.defaultSettings
        },
        "name": {
            title: 'Chacra',
            key: 'name',
            ...this.defaultSettings
        },
        has_changes: {
            title: 'Estado del cálculo',
            key: 'has_changes',
            sortable: false,
            ...this.defaultSettings
            //tiene que estar oculta para aseguradora
        },
        warnings: {
            title: 'Advertencias',
            key: 'warnings',
            sortable: false,
            ...this.defaultSettings
        },
        harvest_type: {
            title: 'Tipo de Cultivo',
            key: 'harvest_type',
            sortable: false,
            ...this.defaultSettings
        },
        start_date: {
            title: 'Inicio',
            key: 'start_date',
            ...this.defaultSettings
        },
        end_date: {
            title: 'Fin',
            key: 'end_date',
            ...this.defaultSettings
        },
        "company__name": {
            title: 'Empresa',
            key: 'company__name',
            ...this.defaultSettings
        },
        "insurance_company__name": {
            title: 'Aseguradora',
            key: 'insurance_company__name',
            ...this.defaultSettings
        },
        progress: {
            title: '% Avance',
            key: 'progress',
            ...this.defaultSettings
        },
        performance: {
            title: 'Rinde',
            key: 'performance',
            ...this.defaultSettings
        },
        humidity: {
            title: 'Humedad',
            key: 'humidity',
            ...this.defaultSettings
        },
        area: {
            title: 'Area',
            key: 'area',
            ...this.defaultSettings
        },
        state: {
            title: 'Estado',
            key: 'state',
            ...this.defaultSettings
        },
        "harvest__farming__name": {
            title: 'Zafra',
            key: 'harvest__farming__name',
            ...this.defaultSettings
        },
        "harvest__farming__insurance_farming__name": {
            title: 'Zafra aseguradora',
            key: 'harvest__farming__insurance_farming__name',
            ...this.defaultSettings
        },
        "ranking": {
            title: 'Ranking',
            key: 'ranking',
            ...this.defaultSettings
        },
        sowing_start: {
            title: 'Fecha Siembra',
            key: 'sowing_start',
            ...this.defaultSettings
        },
        resowing_start: {
            title: 'Fecha Resiembra',
            key: 'resowing_start',
            ...this.defaultSettings
        },
        alerts: {
            title: 'Alertas',
            key: 'alerts',
            sortable: false,
            ...this.defaultSettings
        },
        closing_condition: {
            title: 'Condición de cierre',
            key: 'closing_condition',
            sortable: false,
        },
        actions: {
            title: 'Acciones',
            key: 'actions',
            sortable: false,
            ...this.defaultSettings
        },
    };
    allHeadersFleetSummary: object = {
        ...this.defaultOptions,
        ...this.optionalOptions
    };
    userHeaders: object = this.allHeadersFleetSummary;

    saveUserColumns(columns: string[]) {
        this.$_setUserCustomization({
            analytical_harvest_list_json: columns
        });
    }

    closeModal() {
        this.visibilityModal(false);
        let currentColumns: any = { ...this.userHeaders };
        currentColumns = Object.values(currentColumns)
            .filter(function(item: any) {
                return item['checked'];
            })
            .sort((a: any, b: any) => (a.order > b.order ? 1 : -1))
            .map(function(item: any) {
                return item['key'];
            });



        // console.log("current columns", currentColumns);
        this.saveUserColumns(currentColumns);
    }

    @Watch('$_getUserCustomization', { deep: true, immediate: true })
    observableUserSettings() {
        this.handleUserSettings();
    }

    turnOffAllOptions() {
        for (let i = 0; i < Object.values(this.userHeaders).length; i++) {
            let currentHeader = Object.values(this.userHeaders)[i];
            currentHeader['checked'] = false;
            currentHeader['order'] = 90 + i;
        }
    }

    updateHeadersOrder(newHeaders: Array<object>) {
        let getColumns = newHeaders.map(function(header) {
            return header['value'];
        });
        // console.log("update headers order", getColumns);
        this.saveUserColumns(getColumns);
    }

    handleUserSettings() {
        // console.log("seteo campos listado cosecha");
        this.userHeaders = this.allHeadersFleetSummary;
        let savedUserSettings = this.$_getUserCustomization;
        let backendSummaryFields: string[] = savedUserSettings['analytical_harvest_list_json'];
        let self = this;
        // console.log("backend fields cosecha", backendSummaryFields)
        if (backendSummaryFields && backendSummaryFields.length !== 0) {
            this.turnOffAllOptions(); //all user options checked false
            let headersToShowInTracking = {};
            for (let i = 0; i < backendSummaryFields.length; i++) {
                //loop through all headers keys from backend
                let savedColumn = backendSummaryFields[i]; //current key like speed, vin
                // console.log("savedColumn", savedColumn);
                let currentOption = this.allHeadersFleetSummary[savedColumn]; //current object value
                
                // console.log("this.allHeadersFleetSummary", this.allHeadersFleetSummary);
                let orderValue = i;
                if (currentOption) { 
                    currentOption['checked'] = true;
                    currentOption['order'] = orderValue;
                }
                // console.log("currentOption", currentOption);

                this.userHeaders[savedColumn] = currentOption;
                headersToShowInTracking = {
                    ...headersToShowInTracking,
                    [savedColumn]: currentOption
                };
            }
            this.userHeaders = Object.values(this.userHeaders).sort((a, b) => (a.order > b.order ? 1 : -1));
            this.updateHeadersFleetSummary(
                Object.values(headersToShowInTracking).sort((a: any, b: any) => (a.order > b.order ? 1 : -1))
            );
        } else {
            this.userHeaders = this.defaultOptions;
            this.updateHeadersFleetSummary(Object.values(this.userHeaders));
        }
    }

    columnChecked(itemChecked) {
        let checkedColumns = this.getCheckedHeaders();
        this.updateHeadersFleetSummary(checkedColumns);
    }

    @Emit()
    updateHeadersFleetSummary(selectedHeaders) {
        return selectedHeaders;
    }

    @Emit()
    hideColumnFleetSummary(columnId) {
        return columnId;
    }

    @Emit()
    showColumnFleetSummary(columnId) {
        return columnId;
    }

    getCheckedHeaders() {
        let userHeaders = Object.values(this.userHeaders).filter(function(item) {
            return item['checked'];
        });
        if (userHeaders.length == 0) {
            userHeaders = Object.values(this.defaultOptions).map(function(item) {
                return {
                    ...item,
                    checked: true
                };
            });
        }
        return userHeaders;
    }

    visibilityModal(value) {
        this.visibleModal = value;
    }

    configureVisibleColumns() {
        this.visibilityModal(true);
    }

    mounted() {
        this.handleUserSettings();
    }
}
